'use strict';

import Choices from 'choices.js';

export default class CalculatorModal {
	constructor(toggleBtn) {
        if (!toggleBtn) return false;

        this.toggleBtn = toggleBtn;
        this.modalUrl = toggleBtn.dataset.calculatorToggle;
		this.backetCount = 0;
        this._init();
    }

    _init() {
        this.toggleBtn.addEventListener("click", () => {
			loadModalByUrl(this.modalUrl, {
                afterOpen: (params) => {
                    this.modal = params.modal.firstElementChild;
			    	this.calcBtn = this.modal.querySelector("[data-calculator-modal-calculate]");
			    	this.calcForm = this.modal.querySelector("[data-calculator-modal-form]");
			    	this.resultBlock = this.modal.querySelector("[data-calculator-modal-result-block]");
			    	this.count = this.modal.querySelector("[data-calculator-modal-count]");
			    	this.sum = this.modal.querySelector("[data-calculator-modal-sum]");
                    this.cartBtn = document.querySelector("[data-calculator-cart]");
                    this.useBlock = this.modal.querySelector("[data-calculator-modal-use-block]");
                    this.useText = this.modal.querySelector("[data-calculator-modal-use-text]");
                    this.unitText = this.modal.querySelector("[data-calculator-modal-unit-text]");
                    this.optionalResults = this.modal.querySelector("[data-calculator-modal-optional-results]");

                    this.rowTemplate = this.modal.querySelector("[data-calculator-modal-row-template]");

			    	this.modal.querySelectorAll("input").forEach((input) => {
                        if (!input.readOnly) {
                            input.addEventListener("input", this._onInputChange.bind(this));
                        }
                    })

                    this.modal.querySelectorAll("select").forEach((select) => {
                        $(select).on("change", this._onInputChange.bind(this));
                    })

                    this._onInputChange();

			    	this.calcBtn.addEventListener("click", this._calculate.bind(this));
		            this.cartBtn.addEventListener("click", this._addToCart.bind(this));
                }
            })
		})
    }

    _onInputChange() {
        let isValid = true;
        this.modal.querySelectorAll("[data-calculator-modal-input]").forEach((input) => {
            if (!input.value || (input.tagName === "SELECT" && input.value === "empty")) {
                isValid = false;
            }
        })
        this.calcBtn.disabled = true;

        if (isValid) {
            this._preCalculate();
        }
    }

    _calculate(e) {
        e.preventDefault();

		if (this.calcBtn.disabled) {
			return false;
		}

		this.calcBtn.disabled = true;
        this._sendCalculateRequest({
            attrs: '?action=calculate',
            onSuccess: (res) => {
                res = $.parseJSON(res);
                if (res.result){
                    this.cartBtn.classList.remove("is-hidden");
                    this.count.parentElement.classList.remove("is-hidden");
                    this.sum.closest(".modal-default__row").classList.remove("is-hidden");
					this.resultBlock.classList.remove("is-hidden");

                    if (res.canbuy < res.count) {
                        this.cartBtn.disabled = true;
                    } else {
                        this.cartBtn.disabled = false;
                    }
                    this.count.innerText = res.count;
					this.backetCount = res.count;
                    this.sum.innerText = res.summ;
                    this.resultBlock.classList.add("is-visible");

                    if (res.use_text) {
                        this.useBlock.classList.remove("is-hidden");
                        this.useText.innerText = res.use_text;
                    } else {
                        this.useBlock.classList.add("is-hidden");
                    }

                    this.useText.innerText = res.use_text;
                    this.unitText.innerText = res.unit_text;

                    this.optionalResults.innerHTML = "";

                    if (res.data_result && res.data_result.length) {
                        res.data_result.forEach((data) => {
                            let el = this.rowTemplate.firstElementChild.cloneNode(true);
                            el = this.optionalResults.appendChild(el);
                            el.querySelector("[data-calculator-modal-row-template-key]").innerText = data.title;
                            el.querySelector("[data-calculator-modal-row-template-value]").innerText = data.count;
                            el.querySelector("[data-calculator-modal-row-template-desc]").innerText = data.desc;
                            this.count.innerText = "";
                            this.cartBtn.classList.add("is-hidden");
                            this.count.parentElement.classList.add("is-hidden");
                            this.sum.closest(".modal-default__row").classList.add("is-hidden");
                        })
                    } else {
                        this.count.innerText = res.count;
						this.backetCount = res.count;
                        this.sum.innerText = res.summ;
                        this.calcBtn.classList.remove("is-hidden");
                    }

					this.calcBtn.disabled = false;
                }
            }
        })
    }

    _preCalculate() {
        this._sendCalculateRequest({
            attrs: '?action=preCalculate',
            onSuccess: (res) => {
                res = $.parseJSON(res);
                if (res.result) {
                    for (const [key, value] of Object.entries(res.data)) {
                        const element = this.calcForm.querySelector(`[data-sid=${key}]`);
                        if (element) element.value = value
                    }
                    if (res.use_text) {
                        this.useBlock.classList.remove("is-hidden");
                        this.useText.innerText = res.use_text;
                    } else {
                        this.useBlock.classList.add("is-hidden");
                    }
                    this.unitText.innerText = res.unit_text;
                    this.calcBtn.disabled = false;
                }
            }
        })
    }

    _sendCalculateRequest(params) {
        const attrs = params.attrs;
        const data = $(this.calcForm).serialize();
        const url = this.calcForm.getAttribute("action");

        $.ajax({
            url: url + attrs,
            type: "POST",
            dataType: "html",
            data: data,
            success: params.onSuccess
        });
    }

    _addToCart(e) {
		if (this.cartBtn.disabled) {
			return false;
		}

		this.cartBtn.disabled = true;

		const dataApi = $(this.cartBtn).attr('data-api');
		const dataID = $(this.cartBtn).attr('data-item-id');
		const dataIblockID = $(this.cartBtn).attr('data-iblock-id');

		$.ajax({
			url: dataApi,
			method: 'POST',
			data: {
				id: dataID,
				iblock_id: dataIblockID,
				count: this.backetCount,
			},
			dataType: 'html',
			success: function (data) {
				closeModals();
				$('#basket-modal').find('.basket-modal__dialog').html(data);
				$('#basket-modal').addClass('modal--show').show();
				$(`[data-item-id=${dataID}]`).addClass('in-cart');

				let backdrop = document.createElement('div');
				backdrop.className = 'modal-backdrop';
				document.body.append(backdrop);

				this.cartBtn.false = true;
			},
			error: function (data) {
				console.error(data);
			}
		})

    }
}
